import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { AddCommentButton, OverlayProvider, useShowToast, } from "@madmedical/ui";
import { useMe, usePatientId } from "@madmedical/user";
import { ApiFormWrapper } from "@madmedical/form";
import { useTranslation } from "@madmedical/i18n";
import { useCreateCommentMutation } from "../api";
const AddCommentButtonForm = () => {
    const { patientId } = usePatientId();
    const { roles: { isAdmin }, } = useMe();
    const [createComment] = useCreateCommentMutation();
    const showToast = useShowToast();
    const [isSent, setIsSent] = useState(false);
    const { t } = useTranslation();
    const handleSuccess = () => {
        setIsSent(true);
        showToast(t("commentAdded"), { variant: "success" });
        setTimeout(() => setIsSent(false), 3000);
    };
    if (isAdmin) {
        return null;
    }
    return (_jsx(ApiFormWrapper, Object.assign({ defaultValues: { patientId, date: new Date().toISOString() }, mutation: createComment, onSuccess: handleSuccess, resetOnSuccess: true }, { children: ({ submitForm }) => (_jsx(OverlayProvider, { children: _jsx(AddCommentButton, { onSubmitPress: submitForm, isSuccess: isSent }) })) })));
};
export default AddCommentButtonForm;
